<template>
  <div ref="isRead">
    <div v-show="!isRead" class="crumbs">
      <span class="el-icon-location" /><a class="lanmu" href="/home" target="_blank">首页</a><span>/</span><a class="lanmu" :href="'column?columnId='+list.columnCrumbs[0].COLUMN_ID+'&name='+list.columnCrumbs[0].COLUMN_NAME" target="_blank">{{ list.columnCrumbs[0].COLUMN_NAME }}</a><span>/正文</span>
    </div>
    <div class="box">
      <div ref="box" class="center">
        <div class="title">
          {{ list.cmsContent.CONTENT_TITLE }}
        </div>
        <div class="contentMsg">
          <span>{{ list.cmsContent.CONTENT_ISSUE_DATE|changeTime }}</span><span class="author">{{ list.cmsContent.CONTENT_SOURCE_NAME }}</span><span>{{ list.cmsContent.CONTENT_AUTHOR }}</span>
        </div>
        <div v-if="list.cmsContent.CONTENT_ABSTRACT" class="abstract">
          {{ list.cmsContent.CONTENT_ABSTRACT }}
        </div>
        <div class="bigImg">
          <el-carousel ref="carousel" :interval="3000" arrow="always" height="460px" indicator-position="none" :autoplay="false" @change="changeIndex">
            <el-carousel-item v-for="(item,index) in list.cmsPhoto" :key="item.PHOTO_ID">
              <div class="imgs">
                <img :src="item.PHOTO_URL" alt="" class="" @click="handelImgClick">
              </div>
              <div class="photodesc">
                <span class="nowIndex">{{ index +1 }}</span><span>/{{ list.cmsPhoto.length }}</span>{{ item.PHOTO_DESC }}
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="controlBox">
          <span ref="shangye" class="shang" @click="shangye"><svg-icon icon-class="zuo" /></span>
          <div class="ulBox">
            <ul ref="uls">
              <li v-for="(item,index) in list.cmsPhoto" :key="item.PHOTO_ID" :class="index==currentIndex?'active':'noactive'" @click="handelIndex(index)">
                <img :src="item.PHOTO_URL" alt="">
              </li>
            </ul>
          </div>
          <span ref="xiaye" class="xia" @click="xiaye"><svg-icon icon-class="you" /></span>
        </div>
      </div>
      <div ref="share" class="share">
        <span>分享到:</span>
        <span class="icon" @click="weibo"><svg-icon icon-class="wb" /></span>
        <span class="icon" @click="qq"><svg-icon icon-class="qq" /></span>
        <span class="icon wxImg"><svg-icon icon-class="wx" /> <div id="qrcode" ref="qrcode" /></span>
        <div class="bdsharebuttonbox moreShare">
          <a href="#" class="bds_more el-icon-more" data-cmd="more" />
        </div>
        <span @click="shareImg"><i class="el-icon-share" /></span>
        <span class="btn" @click="shareImg">生成分享图片</span>
        <div class="rightbox">
          <span :class="list.collectionNOrNot?'collected':'nocollected'" @click="goshowcang"><svg-icon icon-class="shoucang" /></span>
          <span class="num">{{ list.cmsCollectionNumber }}</span>
          <span @click="gopinlun"><svg-icon icon-class="pinlun" /></span>
          <span class="num">{{ list.cmsSpeakInNumber }}</span>
          <span class="readBtn" @click="handleRead"><svg-icon icon-class="reading" /></span>
        </div>
      </div>
      <div class="gonext">
        <div v-if="list.nextLastContent.LAST_CONTENT_ID!=='0'" class="next" @click="goDetail(list.nextLastContent.LAST_CONTENT_ID)">
          <div class="imgbox">
            <img v-if="list.nextLastContent.LAST_CONTENT_IMG" :src="list.nextLastContent.LAST_CONTENT_IMG" alt="">
            <img v-else :src="noIMG" alt="">
          </div>
          <div class="imgShadow" />
          <p class="title">
            {{ list.nextLastContent.LAST_CONTENT_TITLE }}
          </p>
          <div class="time">
            <span class="goelse">&lt;&lt;上一篇</span><span class="times">{{ list.nextLastContent.LAST_CONTENT_DATE|changeTime }}</span>
          </div>
        </div>
        <div v-else class="next">
          <p style="text-align: center;height: 86px;line-height: 86px;font-size: 20px;color: #A19D9E;font-weight: 600;">
            已经到顶了
          </p>
        </div>
        <div class="next" @click="goDetail(list.nextLastContent.NEXT_CONTENT_ID)">
          <div class="imgbox">
            <img v-if="list.nextLastContent.NEXT_CONTENT_IMG" :src="list.nextLastContent.NEXT_CONTENT_IMG" alt="">
            <img v-else :src="noIMG" alt="">
          </div>
          <div class="imgShadow" />
          <p class="title">
            {{ list.nextLastContent.NEXT_CONTENT_TITLE }}
          </p>
          <div class="time">
            <span class="goelse">&gt;&gt;下一篇</span><span class="times">{{ list.nextLastContent.NEXT_CONTENT_DATE|changeTime }}</span>
          </div>
        </div>
      </div>
      <div class="likes">
        <div class="title">
          <span>猜你喜欢</span>
        </div>
        <div class="content">
          <Centerlistnews :columnlist="interestedHomeData" />
        </div>
      </div>
      <div class="bookShow">
        <div class="Booktitle">
          <span>推荐家谱</span>
        </div>
        <tuijianBook />
      </div>
      <!--<div class="speak">-->
      <!--<Speak :content-id="list.cmsContent.CONTENT_ID" />-->
      <!--</div>-->
    </div>
    <div v-show="shareImgShow==true" class="showBox">
      <div class="content">
        <canvas id="myCanvasNews" width="432" height="630" style="background-color: #fff;" />
        <div id="qrcode5" ref="qrcode5" style="display: none" />
        <div class="closeBtn" @click="handelClose">
          X
        </div>
      </div>
    </div>
    <div v-show="isRead" class="goback">
      <span @click="handelBack"><svg-icon icon-class="fanhui" /></span>
    </div>
    <div v-show="showBigImg" class="showBigImg" @click="handelcloseImg">
      <div v-for="(item,index) in list.cmsPhoto" :key="index" class="showBigImg_box">
        <img v-if="currentIndex==index" :src="item.PHOTO_URL" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import Centerlistnews from '@/components/centerlist_atlas'
import Speak from '@/components/Detail_speak/index.vue'
import { InterestedHome, addCollect } from '@/api/api.js'
import tuijianBook from '@/views/components/sourceDetail_content/tuijianBookContent/index.vue'
export default {
  name: 'AtlasDetail',
  components: { Centerlistnews, Speak, tuijianBook },
  props: ['list'],
  data() {
    return {
      loginIMG: require('@/static/bg_txz.png'),
      showBigImg: false,
      tag: [],
      isshow: false,
      interestedHomeData: [],
      currentIndex: 0,
      noIMG: require('@/static/home_noimg.png'),
      shareImgShow: false,
      logoImage: require('@/static/logo_gengji22.png'),
      isRead: false
    }
  },
  computed: {
    item() {
      return {}
    }
  },
  asyncData({ store, route }) {
    // return store.dispatch('fetchItem', { id: route.params.id })
  },
  mounted() {
    // this.tag = this.list.cmsContent.CONTENT_TAG.split(',')
    window.scrollTo(0, 0)
    this.wx()
    this.wx2()
    this.canvasInit()
    window.addEventListener('scroll', this.handleScroll, true)
  },
  updated() {
    // this.isRead = false
  },
  created() {
    InterestedHome().then(res => {
      this.interestedHomeData = res.data.cmsContent
    })
  },
  methods: {
    canvasInit() {
      var mycans = document.getElementsByTagName('canvas')[2]// 二维码所在的canvas
      var codeimg = convertCanvasToImage(mycans)

      // /第一个图
      var mycanvas = document.getElementById('myCanvasNews')
      var context = mycanvas.getContext('2d')
      var img1 = new Image()
      // img1.setAttribute('crossOrigin', 'Anonymous')
      img1.src = this.list.cmsContent.CONTENT_PHOTO_SMALL
      var img2 = new Image()
      // img2.setAttribute('crossOrigin', 'Anonymous')
      img2.src = this.logoImage
      var img3 = new Image()
      img3.src = this.loginIMG

      var title = this.list.cmsContent.CONTENT_TITLE
      var avstract = this.list.cmsContent.CONTENT_ABSTRACT
      function drawText(context, t, x, y, w) {
        var chr = t.split('')
        var temp = ''
        var row = []

        context.font = '20px Arial'
        context.fillStyle = '#a19d9e'
        context.textBaseline = 'middle'

        for (var a = 0; a < chr.length; a++) {
          if (context.measureText(temp).width < w && context.measureText(temp + (chr[a])).width <= w) {
            temp += chr[a] // context.measureText(text).width  测量文本text的宽度
          } else {
            row.push(temp)
            temp = chr[a]
          }
        }
        row.push(temp)

        // for (var b = 0; b < row.length; b++) {
        //   context.fillText(row[b], x, y + (b + 1) * 24)// 字体20，间隔24。类似行高
        // }

        // 只显示2行，加...
        for (var b = 0; b < 3; b++) {
          var str = row[b]
          if (b == 2) {
            str = str.substring(0, str.length - 1) + '...'
          }
          context.fillText(str, x, y + (b + 1) * 24)
        }
      }
      img3.onload = function() {
        context.drawImage(this, 0, 0, 432, 630)
        context.drawImage(codeimg, 280, 460, 100, 100)
        context.drawImage(img2, 30, 490, 173, 56)
        context.drawImage(img1, 0, 0, 436, 270)
        // 第二行文字
        context.textAlign = 'center'
        context.font = '27px Arial'
        context.fillStyle = '#333333'
        var title1 = title.slice(0, 15)
        context.fillText(title1, 216, 300)
        if (title.length > 15) {
          var title2 = title.substring(15)
          context.fillText(title2, 216, 340)
        }
        // /第三行文字
        context.textAlign = 'start'
        context.font = '18px Arial'
        context.fillStyle = '#a19d9e'
        if (avstract) {
          drawText(context, avstract, 10, 350, 410)
        }
      }
      // 画上二维码
      function convertCanvasToImage(canvas) {
        var image = new Image()
        image.src = canvas.toDataURL('image/png')
        return image
      }
    },
    handleScroll: function() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (this.$refs.share) {
        if (this.$refs.share.offsetTop + scrollTop - this.$refs.box.offsetHeight - 290 > 0) {
          this.$refs.share.style.position = 'relative'
        }
        if (scrollTop + window.innerHeight < this.$refs.box.offsetHeight + 300) {
          this.$refs.share.style.position = 'fixed'
          this.$refs.share.style.bottom = '0'
        }
      }
    },
    handelBack: function() {
      this.$emit('handelRead', false)
      this.isRead = false
    },
    handleRead: function() {
      this.isRead = true
      this.$emit('handelRead', true)
    },
    handelIndex: function(index) {
      this.$refs.xiaye.style.cursor = 'pointer'
      // this.currentIndex = index
      // var moveX = Math.floor((this.currentIndex + 1) / 4)
      // this.$refs.uls.style.left = -480 * moveX + 'px'
      this.$refs.carousel.setActiveItem(index)
    },
    wx2: function() {
      const qrcode5 = new QRCode('qrcode5', {
        text: window.location.href,
        width: 100,
        height: 100,
        colorDark: '#000', // 黑色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcode5.makeCode(window.location.href)// 生成另一个新的二维码
    },
    handelClose: function() {
      this.shareImgShow = false
      this.$refs.share.style.display = 'block'
    },
    shareImg: function() {
      this.shareImgShow = true
      this.$refs.share.style.display = 'none'
    },
    goDetail: function(contentId) {
      if (contentId == 0) {
        this.$message({
          message: '暂时没有啦',
          type: 'warning'
        })
      } else {
        // this.$router.push({ path: '/Detail', query: { 'contentId': contentId }})
        const { href } = this.$router.resolve({
          path: '/Detail',
          name: 'dt',
          query: {
            contentId
          }
        })
        window.location.href = href
      }
    },
    gocloumn: function(id, name) {
      // this.$router.push({ name: 'column', params: { columnName: id }})
      window.location.href = '/column/?columnId=' + id
    },
    weibo: function() {
      console.log(1111)
      var p = {
        count: '1',
        url: window.location.href,
        // 用于发布微博的来源显示， 为空则分享的内容来源会显示来自互联网。(可选， 允许为空)
        appkey: '彭祖世家网',
        // 分享时所示的文字内容， 为空则自动抓取分享页面的title值(可选， 允许为空)
        title: this.list.cmsContent.CONTENT_TITLE,
        pic: this.list.cmsContent.CONTENT_PHOTO_SMALL,
        ralateUid: '',
        language: 'zh_cn'
      }
      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var url = 'http://service.weibo.com/share/share.php?' + s.join('&')
      window.open(url, '_blank')
    },
    qq: function() {
      var p = {
        /* 获取URL，可加上来自分享到QQ标识，方便统计*/
        url: window.location.href,
        desc: '彭祖世家网',
        /* 分享标题(可选)*/
        title: this.list.cmsContent.CONTENT_TITLE,
        /* 分享摘要(可选)*/
        summary: this.list.cmsContent.CONTENT_ABSTRACT,
        /* 分享图片(可选)*/
        pics: this.list.cmsContent.CONTENT_PHOTO_SMALL,
        /* 视频地址(可选)*/
        flash: '',
        /* 分享来源(可选) 如：QQ分享*/
        site: '彭祖世家网',
        style: '201',
        width: 32,
        height: 32
      }
      var s = []
      for (var i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''))
      }
      var url = 'http://connect.qq.com/widget/shareqq/index.html?' + s.join('&')
      window.open(url, '_blank')
    },
    wx: function() {
      const qrcode = new QRCode('qrcode', {
        text: window.location.href,
        width: 100,
        height: 100,
        colorDark: '#000', // 黑色
        colorLight: '#fff',
        correctLevel: QRCode.CorrectLevel.H
      })
      qrcode.makeCode(window.location.href)// 生成另一个新的二维码
    },
    shangye: function() {
      if (this.currentIndex >= 1) {
        this.currentIndex--
        this.$refs.xiaye.style.cursor = 'pointer'
        // console.log(window.getComputedStyle(this.$refs.uls))
        // var moveX = Math.floor(this.currentIndex / 5)
        // this.$refs.uls.style.left = -480 * moveX + 'px'
        if (this.list.cmsPhoto.length > 6 && this.currentIndex > 4) {
          var moveX = Math.floor(this.currentIndex - 5)
          this.$refs.uls.style.left = -120 * moveX + 'px'
        }
        this.$refs.carousel.setActiveItem(this.currentIndex)
        // this.$refs.uls.style.transform = `translateX(120px)`
      }
      if (this.currentIndex == 0) {
        this.$refs.shangye.style.cursor = 'not-allowed'
      }
    },
    xiaye: function() {
      this.$refs.shangye.style.cursor = 'pointer'
      if (this.currentIndex < this.list.cmsPhoto.length - 1) {
        this.currentIndex++
        // var moveX = Math.floor(this.currentIndex / 5)
        // this.$refs.uls.style.left = -480 * moveX + 'px'
        var moveX = this.currentIndex - 5
        if (moveX > 0) {
          this.$refs.uls.style.left = -120 * moveX + 'px'
        }
        this.$refs.carousel.setActiveItem(this.currentIndex)
        // this.$refs.uls.style.transform = `translateX(${newX}120px)`
      }
      if (this.currentIndex == this.list.cmsPhoto.length - 1) {
        this.$refs.xiaye.style.cursor = 'not-allowed'
      }
    },
    changeIndex: function(index) {
      this.currentIndex = index
      // if (this.currentIndex == 0) {
      //   this.$refs.shangye.style.cursor = 'not-allowed'
      // } else {
      //   this.$refs.xiaye.style.cursor = 'pointer'
      // }
      // if (this.currentIndex == this.list.cmsPhoto.length - 1) {
      //   this.$refs.xiaye.style.cursor = 'not-allowed'
      // } else {
      //   this.$refs.shangye.style.cursor = 'pointer'
      // }
      if (this.list.cmsPhoto.length > 6 && this.currentIndex > 4) {
        var moveX = Math.floor(this.currentIndex - 5)
        this.$refs.uls.style.left = -120 * moveX + 'px'
      }
      if (this.currentIndex < 5) {
        this.$refs.uls.style.left = 0
      }
      // /自动播放时的事件回调
      // var moveX = Math.floor((this.currentIndex) / 2)
      // this.$refs.uls.style.left = -240 * moveX + 'px'
      // this.$refs.carousel.setActiveItem(this.currentIndex)
    },
    gopinlun: function() {
      if (!this.getLoca('userid')) {
        this.$emit('showlogin')
      }
    },
    goshowcang: function() {
      if (this.getLoca('userid')) {
        var obj = {}
        obj.userId = this.getLoca('userid')
        obj.contentId = this.$route.query.contentId
        addCollect(obj).then(res => {
          if (res.data === true) {
            if (this.iscollect) {
              this.$message({
                message: '取消收藏成功',
                type: 'success'
              })
              this.list.cmsCollectionNumber = this.list.cmsCollectionNumber - 1
            } else {
              this.$message({
                message: '收藏成功',
                type: 'success'
              })
              this.list.cmsCollectionNumber = this.list.cmsCollectionNumber * 1 + 1
            }
            this.iscollect = !this.iscollect
          }
        })
      } else {
        this.$emit('showlogin')
      }
    },
    handelImgClick: function() {
      this.showBigImg = true
    },
    handelcloseImg: function() {
      this.showBigImg = false
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .bookShow{
    padding: 0 20px;
    margin-top: 40px;
  }
  .Booktitle{
    margin-bottom: 20px;
    padding-bottom: 5px;
    border-bottom: 2px solid #e5e5e5;
    span{
      display: inline-block;
      padding-left: 7px;
      height: 20px;
      border-left: 2px solid #ed4040;
      font-size: 16px;
      line-height: 20px;
    }
  }
  .goback{
    position: absolute;
    top: 50px;
    left: 80%;
    svg{
      font-size: 60px;
      color: #a19d9e;
      cursor: pointer;
      &:hover{
        color: #333333;
      }
    }
  }
  .showBox{
    position: fixed;
    width: 100%;
    height: 100vw;
    background-color: rgba(0,0,0,.3);
    z-index: 99;
    display: block;
    top: 0;
    left: 0;
    .content{
      background-color: #fff;
      width: 432px;
      height: 630px;
      margin: 0 auto;
      margin-top: 30px;
      position: relative;
      .content_msg{
        overflow: hidden;
        .imgBox{
          width: 432px;
          height: 268px;
          font-size: 0;
          img{
            width: 432px;
            height: 268px;
          }
        }
        .title{
          font-size: 27px;
          color: #333333;
          font-weight: 500;
          text-align: center;
          margin:20px 0;
          height: 36px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        p{
          display:-webkit-box;
          -webkit-line-clamp:3;
          -webkit-box-orient:vertical;
          overflow:hidden;
          word-break: break-all;
          padding: 0 20px;
          font-size: 18px;
          color: #a19d9e;
          line-height: 25px;
          height: 75px;
          margin-bottom: 20px;
          text-align: center;
        }
        .content_foot{
          border-top: 1px dashed #a19d9e;
          padding-top: 20px;
          font-size: 0;
          height: 130px;
          background-color: #fff;
          .logo_img{
            width: 173px;
            height: 56px;
            display: inline-block;
            vertical-align: top;
            margin-right: 86px;
            margin-top: 30px;
            margin-left: 29px;
          }
        }
      }
      .closeBtn{
        position: absolute;
        bottom: -25px;
        left: 191px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #ffffff;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  #qrcode5{
    display: inline-block;
  }
  .moreShare{
    display: inline-block!important;
    vertical-align: top;
    height: 50px;
    line-height: 50px;
    a{
      background-image: none;
      margin-top: 18px;
      color: #FF6357;
      font-size:18px;
    }
  }
  .wxImg{
    position: relative;
    &:hover > #qrcode{
      display: inline-block;
      top: -105px;
      left: -37px;
    }
  }
  #qrcode{
    top: -105px;
    background-color: #fff;
    display: none;
    position: absolute;
    z-index: 5;
  }
  .crumbs{
    height: 40px;
    line-height: 40px;
    border: 1px solid #e5e5e5;
    padding-left: 10px;
    color: #808080;
    background-color: #fff;
    margin-bottom: 20px;
    .lanmu{
      color:#ed4040;
      cursor: pointer;
      margin-left: 3px;
      margin-right: 3px;
    }
  }
  .box{
    background-color: #fff;
    border: 1px solid #e5e5e5;
    .center{
      overflow: hidden;
      padding: 20px 20px;
      background-color: #fff;
      .title{
        font-size: 27px;
        color: #333333;
        font-weight: 500;
      }
      .contentMsg{
        font-size: 12px;
        color: #b2b2b2;
        margin-top: 10px;
        .author{
          margin: 0 20px;
        }
      }
      .abstract{
        padding: 20px;
        margin-top: 20px;
        background-color: #fafafa;
        color: #4d4d4d;
        font-size: 14px;
      }
      .content{
        font-size: 16px;
        color: #4d4d4d;
        margin-top: 30px;
        p{
          height: 20px;
          margin-top: 20px;
        }
        .ziliao{
          margin-left: 5px;
        }
        .download{
          color: #ed4040;
          margin-left: 5px;
        }
        .tagbox{
          margin-top: 20px;
        }
        .active{
          cursor: pointer;
          color: #ffffff;
          background-color: #ed4040;
          border-radius: 2px;
          margin-left: 30px;
          height: 28px;
          line-height: 28px;
          padding: 0 15px;
          display: inline-block;
        }
        .noactive{
          cursor: pointer;
          border: 1px solid #999999;
          color: #9c9e9c;
          border-radius: 2px;
          height: 26px;
          margin-left: 30px;
          line-height: 26px;
          padding: 0 15px;
          display: inline-block;
        }
      }
    }
    .share{
      height: 52px;
      border-bottom:  1px solid #e5e5e5;
      border-top:  1px solid #e5e5e5;
      line-height:52px;
      width: 878px;
      position: fixed;
      bottom: 0;
      background-color: #fff;
      z-index: 9999;
      .btn{
        margin-left: 5px;
        &:hover{
          color: #ed4040;
          cursor: pointer;
        }
      }
      .star{
        display: inline-block;
        float: right;
      }
      span{
        display: inline-block;
        color: #FF6357;
        margin-left: 20px;
        svg{
          font-size: 18px;
          cursor: pointer;
          &:hover{
            color: #ed4040;
          }
        }
        i{
          font-size: 18px;
          cursor: pointer;
          &:hover{
            color: #ed4040;
          }
        }
      }
      .rightbox{
        float: right;
        display: inline-block;
        height: 52px;
        padding: 0 10px;
        .num{
          margin-left: 5px;
        }
        .collected {
          svg {
            color: #ed4040;
          }
        }
        .nocollected{
          svg{
            color: #ccc;
          }
        }
        .readBtn{
          padding-left: 10px;
          border-left: 1px solid #a19d9e;
          height: 20px;
          line-height: 20px;
        }
      }
    }
    .gonext{
      margin-top: 20px;
      margin-bottom: 20px;
      .next{
        display: inline-block;
        width: 410px;
        height: 86px;
        margin-left: 20px;
        position: relative;
        font-size: 0;
        color: #333;
        cursor: pointer;
        vertical-align: top;
        .imgbox{
          /*max-width: 100%;*/
          width: 410px;
          height: 0;
          padding-bottom: 20%;
          /*background-color:#ffffff;!*背景色*!*/
          overflow: hidden;
          img{
          width: 100%;
            margin-top: -50px;
          }
        }
        .imgShadow{
          width: 410px;
          height: 83px;
          position: absolute;
          top: 0;
          z-index: 5;
          background-color:rgba(0,0,0,.3);
          &:hover{
            background-color:rgba(0,0,0,0);
          }
        }
        .title{
          height: 38px;
          overflow: hidden;
          position: absolute;
          top: 15px;
          left: 15px;
          z-index: 6;
          color: #ffffff;
          font-weight: 600;
        }
        .time{
          width: 100%;
          width: 385px;
          position: absolute;
          top: 60px;
          left: 0;
          z-index: 6;
          padding-left: 15px;
          padding-bottom: 10px;
          color: #ffffff;
          .goelse{
            cursor: pointer;
            &:hover{
              color: #ed4040;
            }
          }
          .times{
            float: right;
          }
        }
      }
    }
    .likes{
      display: none;
      margin: 9px 0;
      margin-top: 20px;
      .title{
        margin: 0 20px;
        padding-bottom: 5px;
        border-bottom: 1px solid #e5e5e5;
        span{
          display: inline-block;
          padding-left: 7px;
          height: 20px;
          border-left: 2px solid #ed4040;
          font-size: 16px;
          line-height: 20px;
        }
      }
      .content{
        display: inline-block;
      }
    }
  }
  .bigImg{
   margin: 20px auto;
    overflow: hidden;
    .el-carousel{
      height: 620px;
    }
    .el-carousel__item{
      height: 620px;
    }
    .photodesc{
      font-size: 16px;
      color: #333333;
      margin: 10px auto;
      span{
        margin-right:5px;
      }
      .nowIndex{
        color: #ed4040;
        font-size: 20px;
        font-weight: 500;
      }

    }
  }
  .controlBox{
    text-align: center;
    height: 75px;
    overflow: hidden;
    -webkit-user-select: none;
    user-select: none;
    svg{
      font-size: 25px;
      color: #7e7e7e;
      &:hover{
        color: #ed4040;
      }
    }
    .shang{
      vertical-align: top;
      display: inline-block;
      width: 25px;
      height: 75px;
      background-color: #dcdcdc;
      line-height: 75px;
      cursor: pointer;

    }
    .xia{
      vertical-align: top;
      margin-left: 15px;
      display: inline-block;
      width: 25px;
      height: 75px;
      background-color: #dcdcdc;
      line-height: 75px;
      cursor: pointer;
    }
    .ulBox{
      width: 720px;
      height: 75px;
      overflow: hidden;
      display: inline-block;
      position: relative;
      ul{
        height: 75px;
        display: block;
        width: 20000px;
        text-align: left;
        vertical-align: top;
        position: absolute;
        overflow: hidden;
        left: 0;
        top: 0;
        transition: 1s;
        li{
          font-size: 0;
          margin-left: 15px;
          display: inline-block;
          cursor: pointer;
          img{
            width: 105px;
            height: 75px;
          }
        }
        .active{
          height: 69px;
          width: 99px;
          border: 3px solid red;
          vertical-align: top;
          img{
            width: 99px;
            height: 69px;
          }
        }
      }
    }

  }
  .imgs{
    width: 838px;
    height: 550px;
    overflow: hidden;
    position: relative;
    img{
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .showBigImg{
    position:fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,.9);
    z-index: 99999;
    .showBigImg_box{
      margin: 0 auto;
      text-align: center;
      width: 100vw;
      height: 100vh;
      line-height: 100vh;
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      img{
        max-width: 60%;
        height: auto;
        vertical-align: middle;
      }
    }
  }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .showBigImg{
      position:fixed;
      height: 100vh;
      width: 100vw;
      top: 0;
      left: 0;
      background-color: rgba(0,0,0,.9);
      z-index: 99998;
      overflow-y:hidden;
      .showBigImg_box{
        height: 100vh;
        line-height: 100vh;
        margin: 0 auto;
        text-align: center;
        overflow: hidden;
        img{
          max-width: 100%;
          height: auto;
          vertical-align: middle;
          z-index: 99998;
        }
      }
    }
    .box{
      .gonext{
        .next{
          display: block;
          width: auto;
          margin: 10px 20px;
          overflow: hidden;
          .time{
            width: 100%;
            box-sizing: border-box;
            padding: 0 15px 10px;
          }
          .imgbox{
            height: 9px;
          }
          .imgShadow{
            width: 100%;
          }
        }
      }
      .share{
        display: none;
      }
    }
    .controlBox {
      display: none;
      .ulBox{
        width: calc( 100vw - 125px);
      }
    }
    .imgs{
      width: 100%;
    }
  }
</style>
